module.exports = __webpack_public_path__ + "static/media/logo.4bc1dc8f.svg";